module.exports = __webpack_public_path__ + "img/1539167188.70ef4854.jpg";